<template>
  <PreventionPersonalization form-name="account-settings-mobile" />
</template>

<script>
import PreventionPersonalization from '@/components/Forms/Parts/PreventionPersonalization';

export default {
  name: 'PreventionSettings',
  components: { PreventionPersonalization }
};
</script>
